import { z } from "zod";
import {
  CUSTOM_DAY_VALUES,
  DAY_PRESET_VALUES,
  SHIFT_DURATION_VALUES,
  SHIFT_TYPE_VALUES,
} from "./userAvailability";

export const assignUserAvailabilityBodyRequest = z.object({
  userId: z.coerce.number().positive().optional(),
  dayPresets: z.array(z.enum(DAY_PRESET_VALUES)).default([]),
  customDays: z.array(z.enum(CUSTOM_DAY_VALUES)).default([]),
  shiftDurations: z.array(z.enum(SHIFT_DURATION_VALUES)).default([]),
  shiftTypes: z.array(z.enum(SHIFT_TYPE_VALUES)).default([]),
});

export const getMyAvailabilityRequest = z.object({
  userId: z.coerce.number().positive().optional(),
});
